
import Vue from 'vue'

export default Vue.extend({
  data: () => {
    return {
      dialog: false
    }
  },

  computed: {
    inherited () {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { src, popUpSrc, ...rest } = this.$attrs
      return rest
    },

    popUpSrc () {
      return this.$attrs.popUpSrc || this.$attrs.src
    }
  }
})
